import React from 'react'
import SearchContainer from '../../search/container/Search'
import FilterableCategoryComponent from '../component/FilterableCategory'

const FilterableCategory = props => (
  <SearchContainer {...props} component={FilterableCategoryComponent} />
)

export default FilterableCategory
